import { render, staticRenderFns } from "./breeds-view.vue?vue&type=template&id=f24fef80&scoped=true&lang=pug"
import script from "./breeds-view.js?vue&type=script&lang=js&external"
export * from "./breeds-view.js?vue&type=script&lang=js&external"
import style0 from "./breeds-view.vue?vue&type=style&index=0&id=f24fef80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24fef80",
  null
  
)

export default component.exports